import { render, staticRenderFns } from "./CallMenu.vue?vue&type=template&id=618ac8d4"
import script from "./CallMenu.vue?vue&type=script&lang=js"
export * from "./CallMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports